var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRotateRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9263 7.99956C20.5832 7.99956 21.9263 9.34271 21.9263 10.9996V18.9996C21.9263 20.6564 20.5832 21.9996 18.9263 21.9996H10.9263C9.26944 21.9996 7.9263 20.6564 7.9263 18.9996V10.9996C7.9263 9.34271 9.26944 7.99956 10.9263 7.99956H18.9263ZM18.9263 9.99956H10.9263C10.374 9.99956 9.9263 10.4473 9.9263 10.9996V18.9996C9.9263 19.5518 10.374 19.9996 10.9263 19.9996H18.9263C19.4786 19.9996 19.9263 19.5518 19.9263 18.9996V10.9996C19.9263 10.4473 19.4786 9.99956 18.9263 9.99956ZM10.2463 1.2064L10.3386 1.29173L12.3018 3.34728C12.6463 3.70791 12.6688 4.2609 12.3722 4.64669L12.2914 4.73945L10.3761 6.68535C9.98867 7.07896 9.35553 7.08398 8.96192 6.69656C8.59859 6.33895 8.56636 5.77195 8.86827 5.37726L8.95071 5.28239L9.22719 5.00158C8.49069 4.96774 7.74867 5.09813 7.04815 5.39548C4.50625 6.47445 3.32031 9.40975 4.39928 11.9517C4.61508 12.46 4.37789 13.0471 3.86951 13.2629C3.36113 13.4787 2.77407 13.2415 2.55827 12.7331C1.04771 9.17446 2.70802 5.06503 6.26669 3.55447C7.21012 3.15401 8.21021 2.96998 9.20505 2.99938L9.18087 2.97499L8.89225 2.67311C8.54014 2.30445 8.52544 1.73673 8.83939 1.35155L8.92471 1.25927C9.29338 0.907158 9.8611 0.892455 10.2463 1.2064Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRotateRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconRotateRight.49cc0bd490e94856215128058e61a094.svg";